export const SHOP_TYPE = {
    GROCERY: 'grocery',
    RESTAURANT: 'restaurant'
  }